// extracted by mini-css-extract-plugin
export default {"color-div":"KPIChartStats_color-div__2GhqP","green-bg":"KPIChartStats_green-bg__18OMz","text-gray":"KPIChartStats_text-gray__5Dxr3"};